import * as React from 'react';
import { Item } from '../../../../../../components/Grid';
import HistoryRow from '../../../../../../components/HistoryRow';
import HistoryRowControls from '../../../../../../components/HistoryRowControls';
import HistoryRowListing from '../../../../../../components/HistoryRowListing';
import { IHistoryContext } from '../../../../../../containers/FormContextHandler';
import { formatPartialDate } from 'Utility/date';
import { newButton } from '../../../../utils/functions';
import { formatSeizureClassification } from '../../../../../Seizure/utils';
import InfoPopover from 'Components/InfoPopover';
import Icon from 'Components/_NewElements/Icon';
import ToolTip from 'Components/ToolTip';

const SeizureTypeHistory = (props: IHistoryContext<ISeizureType>): React.JSX.Element => {
  const { startEdit, fm, documents } = props;
  const prefix = 'diagnosis.epilepsy.seizureType.'; // for localization

  const makeRow = (doc: ISeizureType): React.JSX.Element => (
    <>
      <Item xs={4}>{doc.freeDescription ?? '-'}</Item>
      <Item xs={3}>{doc.nameByPatient ?? '-'}</Item>
      <Item xs={3}>
        {doc.classification && doc.classification.classification
          ? formatSeizureClassification(doc.classification?.classification, 'long', true)
          : '-'}
      </Item>

      <Item xs={2} style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ whiteSpace: 'nowrap' }}>
          {doc.firstOccurenceDate
            ? formatPartialDate(doc.firstOccurenceDate) !== ''
              ? formatPartialDate(doc.firstOccurenceDate)
              : doc.firstOccurenceDate.filter(n => n).join('/')
            : '-'}
        </div>
        {doc.visibleToPatient && (
          <div style={{ position: 'relative', left: '25%' }}>
            <ToolTip title={fm(prefix + 'visibleForPatient')} content={<Icon icon="visibility" />} hover={true} />
          </div>
        )}
      </Item>
    </>
  );
  return (
    <React.Fragment>
      <HistoryRow
        headerText={fm && fm('diagnosis.epilepsy.seizureType.title')}
        rowButton={startEdit ? newButton('seizureType', startEdit({}, 'seizureType'), 'general.new', 15) : undefined}
      >
        <HistoryRowListing
          headers={
            <>
              <Item xs={4}>{fm && fm(prefix + 'seizureFreeDescription')}</Item>
              <Item xs={3}>
                {fm && fm(prefix + 'seizureNameByPatient')}
                <span style={{ marginLeft: '1rem' }}>
                  <InfoPopover text="diagnosis.epilepsy.seizureType.seizureNameByPatientInfotext" color="primary" />
                </span>
              </Item>
              <Item xs={3}>{fm && fm(prefix + 'seizureClassification')}</Item>

              <Item xs={2}>{fm && fm(prefix + 'firstOccurenceDate')}</Item>
            </>
          }
          contentFormat={makeRow}
          documents={documents}
          dateFieldName={'firstOccurenceDate'}
          collapse={false}
          makeControls
          historyRowControls={(d: IControlProps) =>
            startEdit ? <HistoryRowControls document={d} startEdit={startEdit} /> : <></>
          }
        />
      </HistoryRow>
    </React.Fragment>
  );
};

export default SeizureTypeHistory;
